/**
 * Preco do "Gerar boleto" em /detalhes-da-empresa. O provedor nao emite boleto
 * abaixo de R$ 5,00 e a API ja recusa; aqui o erro aparece embaixo do campo,
 * antes de enviar.
 */
export const BOLETO_MIN_PRICE = 5;

/** "R$ 1,234.56" (v-money com masked:false) -> 1234.56; vazio ou lixo -> 0. */
export const parseMoney = (value) => {
  const number = parseFloat(String(value || '').replace(/[^\d.]/g, ''));
  return isNaN(number) ? 0 : number;
};

export const boletoPriceError = (value) => {
  const price = parseMoney(value);
  if (price <= 0) return 'Valor obrigatório.';
  if (price < BOLETO_MIN_PRICE) return 'Valor mínimo R$ 5,00.';
  return '';
};



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/companyDetail/boletoPrice.js